import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountRtpReady = (account: IAccount) =>
  account.status !== AccountStatus.Inactive && account.canBeUsedFor?.rtp;
